import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {OneTimePermissionRequestContainerModel} from '../../../../../models/aggregates/permissions';
import { ApiResponseModel, ApiVisa } from '../shared';
import { Observable } from 'rxjs';

// /core2/tnt/dm/applet/perm/one-time-perm-request-queues/backoffice-ep

@Injectable({
  providedIn: 'root'
})
export class OneTimePermRequestQueueService extends BaseApiTemplateService<OneTimePermissionRequestContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-queues/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-queues/backoffice-ep';
    this.httpClient = http;
  }

  // /core2/tnt/dm/applet/perm/one-time-perm-request-queues/send-email/backoffice-ep
  requestForApprovalAndSendEmail(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      if (visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-queues/send-email/backoffice-ep';
      }
      return this.httpClient.post<ApiResponseModel<any>>(
        this.apiUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

   // /core2/tnt/dm/applet/perm/one-time-perm-request-queues/retrieve-approval/backoffice-ep?gen_doc_line_guid=59158b8c-e57b-2017-b930-45171e8a1a7b

   getApprovalStatus(lineGuid: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let dto = {};
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-queues/retrieve-approval/backoffice-ep?gen_doc_line_guid=' + lineGuid;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }

  getApprovalStatusHdr(hdrGuid: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let dto = {};
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'perm/one-time-perm-request-queues/retrieve-approval-hdr/backoffice-ep?generic_doc_hdr_guid=' + hdrGuid;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }
}


